import { ExpertNoteIdentifier } from '@@types/api.types';
import type { MissionAssessmentFormData } from '@schemas/mission-assessment.schema';
import { formOptions } from '@tanstack/react-form';

export const missionAssessmentDraftFormOptions = formOptions({
  defaultValues: {
    capabilities: [],
    communities: [],
    data: {
      expertNotes: [
        { identifier: ExpertNoteIdentifier.THREATS, content: '' },
        { identifier: ExpertNoteIdentifier.STRATEGIC, content: '' },
        { identifier: ExpertNoteIdentifier.RISKS, content: '' },
        { identifier: ExpertNoteIdentifier.SUSTAINMENT, content: '' },
      ],
      generalNotes: '',
      hurdles: {
        nextMrl: '',
        nextMrlScore: undefined,
        nextTrl: '',
        nextTrlScore: undefined,
        supplyChain: '',
      },
      maxPhase: undefined,
      minPhase: undefined,
    },
    effects: [],
    inters: [],
    killChains: [],
    recommendedDomains: [],
    recommendedServices: [],
    recommendedTechnologyUses: [],
    recommendedUses: [],
    taskRecommendations: [],
  } as MissionAssessmentFormData,
});
